import { GET_LEADS_CAP_REGISTRATION_REQUEST, GET_LEADS_CAP_REGISTRATION_REQUEST_SUCCESS, GET_LEADS_CAP_REGISTRATION_REQUEST_FAILURE } from '../../constants/cap.constants';

export const getLeadsCapRegistrationRequest = (derivative_introduced, derivative_discontinued) => ({
    type: GET_LEADS_CAP_REGISTRATION_REQUEST, derivative_introduced, derivative_discontinued,
});
export const getLeadsCapRegistrationRequestSuccess = payload => ({ type: GET_LEADS_CAP_REGISTRATION_REQUEST_SUCCESS, payload });
export const getLeadsCapRegistrationRequestFailure = error => ({ type: GET_LEADS_CAP_REGISTRATION_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/cap_actions/get_cap_registration.actions.js